(function () {
  const cartAddUrl =
    window.Shopify?.routes?.root != null
      ? `${window.Shopify.routes.root}cart/add.js`
      : '/cart/add.js';
  const cartUrl =
    window.Shopify?.routes?.root != null ? `${window.Shopify.routes.root}cart` : '/cart';
  const checkoutUrl = () => window.grefiCheckout?.checkoutUrl || '/checkout';

  async function addVariant(variantId, quantity) {
    const res = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: quantity || 1 }],
      }),
    });

    if (!res.ok) {
      let message = 'Could not add to cart';
      try {
        const err = await res.json();
        message = err.description || err.message || message;
      } catch {
        /* ignore */
      }
      throw new Error(message);
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
    return res.json();
  }

  function goCheckout(trigger) {
    if (typeof window.grefiStartCheckout === 'function') {
      window.grefiStartCheckout(trigger || null);
      return;
    }
    window.location.href = checkoutUrl();
  }

  function setLoading(btn, on, labelSel, loadingText) {
    if (!btn) return;
    const label = btn.querySelector(labelSel);
    btn.classList.toggle('is-loading', on);
    btn.disabled = on;
    if (!label) return;
    if (on) {
      btn.dataset.prevLabel = label.textContent;
      label.textContent = loadingText || '…';
    } else if (btn.dataset.prevLabel) {
      label.textContent = btn.dataset.prevLabel;
    }
  }

  async function onAtc(btn) {
    const id = btn.dataset.variantId;
    if (!id || btn.disabled) return;

    setLoading(btn, true, '[data-grefi-card-atc-label]', 'Adding…');
    try {
      await addVariant(id, 1);
      window.location.href = cartUrl;
    } catch (err) {
      setLoading(btn, false, '[data-grefi-card-atc-label]');
      window.alert(err.message || 'Could not add to cart');
    }
  }

  async function onBuy(btn) {
    const id = btn.dataset.variantId;
    if (!id || btn.classList.contains('is-loading')) return;

    setLoading(btn, true, '[data-grefi-card-buy-label]', btn.dataset.loading || 'Redirecting…');
    try {
      await addVariant(id, 1);
      goCheckout(btn);
    } catch (err) {
      setLoading(btn, false, '[data-grefi-card-buy-label]');
      window.alert(err.message || 'Could not start checkout');
    }
  }

  document.addEventListener('click', (e) => {
    const atc = e.target.closest('[data-grefi-card-atc]');
    if (atc) {
      e.preventDefault();
      e.stopPropagation();
      onAtc(atc);
      return;
    }

    const buy = e.target.closest('[data-grefi-card-buy]');
    if (buy) {
      e.preventDefault();
      e.stopPropagation();
      onBuy(buy);
    }
  });
})();
